export default __webpack_public_path__ + "static/media/sony-headphones.1c1bbbd9.jpg";